import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../common/Button/Button';
import styles from './OverviewSections.module.css';

/**
 * The closing banner. It repeats the page's main button, so a student who has
 * read to the bottom does not have to scroll back up. `label` is the same
 * Start / Continue text the header button uses.
 */
const ApplicationCtaBanner = ({ stageName, label, onStart }) => (
  <div className={styles.banner}>
    <h3 className={styles.bannerTitle}>
      {stageName ? `Ready to work on your ${stageName}?` : 'Ready to work on your application?'}
    </h3>
    <Button onClick={onStart}>{label} →</Button>
    <div>
      <Link to="/student/competitions" className={styles.bannerBack}>
        ← Back to My Competitions
      </Link>
    </div>
  </div>
);

export default ApplicationCtaBanner;
